import { Pipe, PipeTransform } from '@angular/core';
import { StepStateCodes } from '../../models/const.Contants';

@Pipe({
    name: 'toIcon',
    standalone: false
})
export class ToIconPipe implements PipeTransform {

  transform(value: any): string {
    switch (value) {
      case StepStateCodes.error: return "icon-error";
      case StepStateCodes.toValidate: return "icon-164";
      case StepStateCodes.valid: return "icon-ok";
      case StepStateCodes.dOverlap: return "icon-ok";


      default: return undefined;
    }
  }

}

@Pipe({
    name: 'toIconClass',
    standalone: false
})
export class ToIconClassPipe implements PipeTransform {
  transform(value: any): string {

    switch (value) {
      case StepStateCodes.error: return "text-danger";
      case StepStateCodes.toValidate: return "text-warning";
      case StepStateCodes.valid: return "text-success";
      case StepStateCodes.dOverlap: return "text-success";

      default: return undefined;

    }
  }
}
